import React from "react";

import Fintalk from "./assets/img/clients/Fintalk-Logo.png";
import FintalkInsu from "./assets/img/clients/FintalkInsurance.png";
import FintalkInvest from "./assets/img/clients/FintalkInvestments.png";
import Flashcode from "./assets/img/clients/Flashcodelogo.png";
import FreshFarm from "./assets/img/clients/FreshFarmLogo.jpg";
import FoodTech from "./assets/img/clients/foodtechlogo.png";
import Aristone from "./assets/img/clients/ariston_engineers_logo.png";
import Trradex from "./assets/img/clients/Trradex_Capital_logo.jpg";

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';


const Clients = () =>{
    return (
        <section id="clients" class="clients">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Clients</h2>
          <p>Our Valuable Trusted Clients</p>
        </div>

        <div class="row no-gutters clients-wrap clearfix wow fadeInUp">

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="">
              <img src={Fintalk} class="img-fluid" title="Fintalk Services" alt="Fintalk"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={Trradex} class="img-fluid" title="Trradex Capital" alt="Trradex"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={Aristone} class="img-fluid" title="Aristone Bim Service LLP" alt="Aristone"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={FintalkInsu} class="img-fluid" title="Fintalk Insurance" alt="Fintalk-Insurance"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={FintalkInvest} class="img-fluid" title="Fintalk Investment" alt="Fintalk-Investments"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={Flashcode} class="img-fluid"  title="Flashcode" alt="Flashcode"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6">
            <div class="client-logo" data-aos="" data-aos-delay="">
              <img src={FreshFarm} class="img-fluid"title="Freshfarm Mobile App"  alt="FreshFarm"/>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-xs-6" data-aos="" data-aos-delay="">
            <div class="client-logo">
              <img src={FoodTech} class="img-fluid" title="College of Food Technology" alt="College of Food Technology"/>
            </div>
          </div>

        </div>

      </div>
    </section>

    )
}


export default Clients;